/* eslint-disable node/no-unsupported-features/es-syntax */
/* eslint-disable filenames/no-index */
import { SpawnGameLauncher } from "@spawn/launcher";

/**
 * The SpawnGameLauncher created the game. You don't need to change anything here.
 */
SpawnGameLauncher.entrypoint = () => import(/* webpackChunkName: "game" */ "./main");
